/**
 * Created by orenm on 11/23/2014.
 */
define(function (require) {
    "use strict";

    var BaseCollection = require("collections/BaseCollection");
    var SnippetModel = require("connection-models/KPsTab/SnippetModel");
    var ApiResources = require("assets/data/apiResources.json");
    var CP_CONST = require("connection-const");

    var NewSnippetsCollection = {};
    LE.module('LEConnection', function (LEConnection, LE, Backbone, Marionette, $, _) {
        NewSnippetsCollection = BaseCollection.extend({

            initialize: function (options) {

            }



        });
    });

    return NewSnippetsCollection;
});
